<mat-progress-bar mode="indeterminate" *ngIf="isShowLoader" color="accent"></mat-progress-bar>
<div class="container">
    <div @fadeIn *ngIf="popupType==='LIST'">
        <div fxLayout="row wrap" class="header m-b-10">
            <div fxFlex="93" fxLayoutAlign="center center">
                <span class="header-text">Labels</span>
            </div>
            <div class="pointer" (click)="onClosePopup()">
                <mat-icon>clear</mat-icon>
            </div>
        </div>
        <div fxLayout="row wrap" class="search-label">
            <form fxFlex="100">
                <mat-form-field appearance="outline">
                    <input name="searchText" matInput placeholder="Search labels..." [(ngModel)]="searchText">
                </mat-form-field>
            </form>
        </div>
        <div fxLayout="row wrap" class="m-b-10">
            <span class="title">LABELS</span>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="space-between center" *ngIf="labels.length">
            <div @fadeIn fxFlex="48" class="label-container m-b-5"
                *ngFor="let item of labels | sortData: 'labelText' : searchText "
                [ngStyle]="{'background': item.labelColor}">
                <div class="color m-b-15 pointer">
                    <mat-label fxLayoutAlign="space-between center" (click)="onAddRemoveLabel(item)">
                        <span>{{item.labelText}}</span>
                        <mat-icon *ngIf="item.selected">done</mat-icon>
                    </mat-label>
                </div>
                <div fxLayoutAlign="end center">
                    <mat-icon (click)="onEdit(item)" class="pointer m-r-10">edit</mat-icon>
                    <mat-icon (click)="onDelete(item)" class="pointer">delete</mat-icon>
                </div>
            </div>
        </div>
        <div fxLayout="row wrap" *ngIf="!labels.length">
            <span>No labels found!</span>
        </div>
        <div fxLayout="row wrap" class="m-t-20">
            <button class="add-label" type="button" (click)="onCreateBtnClick()" fxFlex="100" mat-raised-button>Create a
                new
                label</button>
        </div>
    </div>

    <div @fadeIn *ngIf="popupType==='ADD_EDIT'">
        <div fxLayout="row wrap" class="header m-b-10">
            <div>
                <mat-icon class="pointer" (click)="goBack()">keyboard_arrow_left</mat-icon>
            </div>
            <div fxFlex="86" fxLayoutAlign="center center">
                <span class="header-text">Create Label</span>
            </div>
            <div class="pointer" (click)="onClosePopup()">
                <mat-icon>clear</mat-icon>
            </div>
        </div>
        <div fxLayout="row wrap" class="search-label">
            <form fxFlex="100">
                <span class="title">Name</span>
                <mat-form-field appearance="outline">
                    <input name="searchText" matInput [(ngModel)]="selectedLabel.labelText">
                </mat-form-field>
            </form>
        </div>
        <div fxLayout="row wrap" class="m-b-10">
            <span class="title">Select a color</span>
        </div>
        <div fxLayout="row wrap">
            <div @fadeIn *ngFor="let item of colors">
                <mat-label fxLayoutAlign="center center" [ngStyle]="{'background': item.labelColor}"
                    (click)="onSelectLabelColor(item)" class="pointer color pick-color">
                    <mat-icon *ngIf="item.selected">done</mat-icon>
                </mat-label>
            </div>
        </div>
        <div fxLayout="row wrap" class="m-t-20" *ngIf="mode === 'create'">
            <button [disabled]="!selectedLabel.labelColor" color="primary" class="font-16" type="button"
                (click)="onCreate()" mat-raised-button>Create</button>
        </div>
        <div fxLayout="row wrap" class="m-t-20" *ngIf="mode === 'edit'">
            <button color="primary" class="font-16" type="button" (click)="onUpdate()" mat-raised-button>Update</button>
        </div>
    </div>

    <div @fadeIn *ngIf="popupType==='DELETE'">
        <div fxLayout="row wrap" class="header m-b-10">
            <div>
                <mat-icon class="pointer" (click)="goBackFromDelete()">keyboard_arrow_left</mat-icon>
            </div>
            <div fxFlex="86" fxLayoutAlign="center center">
                <span class="header-text">Delete Label?</span>
            </div>
            <div class="pointer" (click)="onClosePopup()">
                <mat-icon>clear</mat-icon>
            </div>
        </div>
        <div fxLayout="row wrap">
            <h4>This will remove this label from all cards</h4>
        </div>
        <div fxLayout="row wrap">
            <button color="warn" class="delete-label" type="button" (click)="onDeleteBtnClick()" fxFlex="100"
                mat-raised-button>Delete</button>
        </div>
    </div>
</div>